<div class="mt-5 mb-16 w-full px-6 py-4 md:px-16">
  <dhp-header
    [title]="'pages.editors.editorsTitle' | translate"
    [subtitle]="'pages.editors.overviewOfEditorsAndEmployees' | translate"
    [searchPlaceholder]="'pages.authors.filterByLastName' | translate"
    [showFilter]="true"
    [selectedMagazineIds]="selectedMagazineIds"
    (searchOutput)="onSearch($event)"
    (magazineSelected)="onMagazinesChange($event)"
  ></dhp-header>
  <dhp-editors-list></dhp-editors-list>
</div>
